<template>
  <div>
    <slot name="uploadButton" />

    <v-dialog
      v-model="showUploadDialog"
      persistent
      :retain-focus="false"
      transition="slide-y-transition"
    >
      <v-card class="pa-2 pt-0 pb-0">
        <v-container>
          <v-row
            no-gutters
            align="center"
          >
            <v-col class="headline ml-1">
              {{ title }}
            </v-col>

            <v-col cols="auto">
              <v-btn
                small
                fab
                icon
                @click="hideModal"
                :disabled="uploading"
              >
                <v-icon>
                  close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-file-input
                v-model="file"
                label="Select File"
                show-size
                dense
                class="pr-5"
                hide-details
                :clearable="clearable"
                :disabled="uploading"
                @change="handleFileSelect"
              />
              <span
                v-if="!!supportedFiles"
                class="subtitle-2 mt-3 ml-3 grey--text"
              >
                Supported files: {{ supportedFiles }}
              </span>
            </v-col>
          </v-row>

          <v-row class="text-center">
            <v-col>
              <v-btn
                cols="12"
                rounded
                color="primary"
                :class="{ 'disable-events': !file }"
                :disabled="!file"
                :loading="uploading"
                @click="upload"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IUser } from '@/types/models/user.model'

@Component({
  computed: {
    ...mapGetters(['profile'])
  }
})
export default class UploadCV extends Vue {
  @Prop({ default: false }) uploading: boolean
  @Prop({ default: false }) showUploadDialog: boolean
  @Prop({ default: 'Upload' }) title: string
  @Prop() supportedFiles: string

  // data
  clearable: boolean = false
  file: null|File = null

  // computed
  profile: IUser

  @Watch('showUploadDialog')
  onShowUploadDialogChanged (val: number, oldVal: number) {
    if (val) {
      this.file = null
    }
  }

  // methods
  hideModal () {
    this.$emit('hideModal')
  }

  async upload () {
    this.$emit('upload', this.file)
  }

  handleFileSelect (file: File) {
    this.$emit('selectFile', file)
  }
}
</script>
<style lang="scss" scoped>
.disable-events { pointer-events: none }
</style>
